import { apiClient } from './client';
import type { ClientsPageMeta } from './clients';

/**
 * Отчёт о выданных УЕ — /reports/give (см. докблок ReportsController в
 * Laravel, 1:1 старый Orchid ReportGiveListScreen).
 */
export interface GiveReportRow {
  id: number;
  createdAt: string;
  /** Компания-получатель у.е. */
  recipient: string | null;
  recipientId: number | null;
  sender: string | null;
  tutor: string | null;
  operation: string | null;
  description: string | null;
  value: number;
}

export interface FetchGiveReportParams {
  search?: string;
  operation?: string;
  tutorId?: string;
  sort?: string;
  page?: number;
}

export interface GiveReportPage {
  items: GiveReportRow[];
  meta: ClientsPageMeta;
}

export async function fetchGiveReport(params: FetchGiveReportParams = {}): Promise<GiveReportPage> {
  const { data } = await apiClient.get<GiveReportPage>('/reports/give', { params });
  return data;
}

export interface GiveReportFilters {
  operations: string[];
  tutors: { value: string; label: string }[];
}

export async function fetchGiveReportFilters(): Promise<GiveReportFilters> {
  const { data } = await apiClient.get<GiveReportFilters>('/reports/give/filters');
  return data;
}

/**
 * Выгрузка в Excel. Ответ бинарный, поэтому запрашивается blob'ом и
 * скачивается через временную ссылку — обычный переход по URL не подошёл бы:
 * запрос идёт с сессионной cookie через BFF и должен пройти тот же слой,
 * что и остальные вызовы API.
 */
export async function downloadGiveReport(params: FetchGiveReportParams = {}): Promise<void> {
  const response = await apiClient.get('/reports/give/export', {
    params: { search: params.search, operation: params.operation, tutorId: params.tutorId },
    responseType: 'blob',
  });

  const url = URL.createObjectURL(response.data as Blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'Отчет о выданных УЕ.xlsx';
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
